import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import CopyBox from '../components/bbcode/copy-box';
import Share from '../components/share/share';

import moment from 'moment';
import { DateTime } from 'luxon';

import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

export default class DJAreaSocials extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			share: false,
			Home: {},
			Clubbers: [],
			Radio: [],
			Schedule: [],
			schedules: 8,

			discord: '/images/socials/discord.png',
			facebook: {},
			website: '/images/socials/website.png',
			facebook_time: 0,
		};
		this.fetchSocials = this.fetchSocials.bind(this);
		this.share = this.share.bind(this);
		this.showMore = this.showMore.bind(this);
  };

  async componentDidMount() {
		document.title = "Admin Users - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var d = new Date();
		d.setUTCHours(21);
		d.setMinutes(0);
		d.setSeconds(0);
		this.setState({facebook_time: Math.floor(d.getTime()/1000)});

		this.fetchSocials();
	}

	componentWillUnmount() {
	}

	async fetchSocials() {
		let params = new URLSearchParams();
		params.append('schedules', this.state.schedules);
		const x = await postApi('/api/v2/djarea/socials', params);
		console.log(x.data);
		this.setState({Home: x.data.Home, Clubbers: x.data.Clubbers, Schedule: x.data.Schedule, facebook: x.data.Facebook});
	}

	share(e) {
		this.setState({share: e.toLowerCase()});
	}
	close = (childData) => {
    this.setState({scheduleadd: false, scheduleedit: false, share: false});
	}

	showMore() {
		if( this.state.schedules === 8 ) {
			this.setState({schedules: 100},()=>{this.fetchSocials()});
		} else {
			this.setState({schedules: 8},()=>{this.fetchSocials()});
		}
	}
	

	render() {
		let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
		const facebook = 
      Object.keys(this.state.facebook).map((e,i) => {
        return (
					<div className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest" key={i} style={{width: 404, fontSize: 12}}>
						{/*<img src={`${this.state.facebook[e].image}&d=${Date.now()}`} alt="facebook image" widht="384" height="288" style={{paddingRight: 20}} /><br /><br />
						user.user.user?.rank >= 5&&
							<button className="pagelayer-contact-submit-btn pagelayer-btn-holder pagelayer-ele-link pagelayer-btn-custom pagelayer-btn-mini {{icon_position}}" style={{fontSize: 12, paddingTop: 8, paddingRight: 15, paddingBottom: 8, paddingLeft: 15}}>Update</button>
						*/}
					</div>
        )
      })
		const schedule = 
      this.state.Schedule.map((e,i) => {
        return (
					<Col className="mb-4" key={i}>
						<img src={`https://mix365.co.uk${this.state.Schedule[i].image}`} widht="384" height="288" alt="Mix365 Schedule" className="mb-2" /><br />
						<Button size="sm" onClick={()=>this.share(this.state.Schedule[i].location)}>Share</Button>&nbsp;&nbsp;https://mix365.co.uk{this.state.Schedule[i].location}<br />
						{this.state.Schedule[i].title}<br />
						{this.state.Schedule[i].description}
					</Col>
        )
      })
		const clubbers = 
			Object.keys(this.state.Clubbers).map((e,i) => {
        return (
					<Col key={i}>
						<img src={this.state.Clubbers[e].image} widht="384" height="288" alt="Mix365 Clubbers" className="mb-2" /><br />
						<Button size="sm" onClick={()=>this.share(`/clubbers/${days[moment(this.state.Clubbers[e].id*1000).day()]}`)}>Share</Button>&nbsp;&nbsp;
						https://mix365.co.uk/clubbers/{days[moment(this.state.Clubbers[e].ctime*1000).day()]}<br />
						<CopyBox content={this.state.Clubbers[e].title.replaceAll('\n',' [br]')} />
					</Col>
        )
      })
		const radio = 
			Object.keys(this.state.Radio).map((e,i) => {
        return (
					<Col key={i}>
						<img src={this.state.Radio[e].image} widht="384" height="288" alt="Mix365 Radio" className="mb-2" /><br />
						<Button size="sm" onClick={()=>this.share(`/radio/${days[moment(this.state.Radio[e].id*1000).day()]}`)}>Share</Button>&nbsp;&nbsp;
						https://mix365.co.uk/radio/{days[moment(this.state.Radio[e].ctime*1000).day()]}<br />
						<CopyBox content={this.state.Radio[e].title.replaceAll('\n',' [br]')} />
					</Col>
        )
      })
		return (
			<>
				<Row className="dj-area pt-4 pb-5 px-4">
					<Col xs={12} md={2} className="djarea-sidemenu">
						<DJAreaSideMenu />
					</Col>
					<div className="col-12 col-sm-9 col-lg-10">

						{Object.keys(this.state.Home).length > 0 &&
							<Row>
								<Col>
									<div className="card bg-dark">
										<div className="card-header">
											<h3 className="card-title">Mix365 Website Socials</h3>
											
										</div>
										<div className="card-body">
											<img src={`https://mix365.co.uk${this.state.Home.image}`} widht="384" height="288" alt="Mix365 Homepage" className="mb-2" /><br />
											<Button size="sm" onClick={()=>this.share(this.state.Home.location)}>Share</Button>&nbsp;&nbsp;
											https://mix365.co.uk{this.state.Home.location}<br />
											{this.state.Home.description}
										</div>
										<div className="card-footer">
											
										</div>
									</div>
								</Col>
							</Row>
						}

						
						<Row>
							<Col>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Mix365 Clubbers Schedule</h3>
									</div>
									<div className="card-body">
										<Row>
											{clubbers}
										</Row>
									</div>
								</div>
							</Col>
						</Row>

						<Row>
							<Col>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Mix365 Radio Schedule</h3>
									</div>
									<div className="card-body">
										<Row>
											{radio}
										</Row>
									</div>
								</div>
							</Col>
						</Row>
					
					
						{this.state.Schedule.length > 0 &&
							<Row>
								<Col>
									<div className="card bg-dark">
										<div className="card-header">
											<h3 className="card-title">Mix365 Live</h3>
											<div className="card-tools">
												<Button onClick={this.showMore} size="sm">{this.state.schedules===8?'Show More':'Show Less'}</Button>
											</div>
										</div>
										<div className="card-body">
											<Row>
												<Col xs={12}>To view more click show more over to the right<br /><br /></Col>
												{schedule}
											</Row>
										</div>
										<div className="card-footer">
										</div>
									</div>
								</Col>
							</Row>
						}
					</div>
				</Row>
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}
